<template>
  <div>
    <section
      v-if="$slots.header"
      class="bg-semantic-inverse-surface text-white py-6 md:py-8 px-4 xl:px-0"
    >
      <div class="w-full max-w-wrapper-lg mx-auto">
        <slot name="header" />
      </div>
    </section>

    <section class="px-4 xl:px-0 py-10 mx-auto">
      <slot name="content" />
    </section>
  </div>
</template>

<script setup>
defineOptions({
  name: 'LayoutsContentfulCategoryAuthor'
})
</script>
